import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-comparison',
  standalone: true,
  imports: [TranslateModule],
  template: `
    <section class="py-20 md:py-28 bg-dark-200 relative overflow-hidden">
      <div class="max-w-7xl mx-auto px-5 md:px-10">
        
        <div class="max-w-xl mb-14" data-aos="fade-up">
          <p class="text-primary font-bold text-xs tracking-[0.2em] uppercase mb-3">{{ 'COMPARISON.LABEL' | translate }}</p>
          <h2 class="text-3xl md:text-[2.75rem] font-black mb-4 leading-[1.1]">
            {{ 'COMPARISON.TITLE' | translate }}
          </h2>
        </div>

        <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          
          <!-- Spotify -->
          <div class="bg-dark-300 border border-white/[0.04] rounded-2xl p-6" data-aos="fade-up" data-aos-delay="100">
            <div class="h-8 mb-4 flex items-center">
              <img src="other/Spotify_logo_with_text.svg.png" alt="Spotify" class="max-h-6 brightness-0 invert" />
            </div>
            <p class="text-xs text-gray-650 mb-5">Discovery</p>
            <div class="space-y-2.5 text-xs">
              <div class="flex justify-between items-center py-1.5 border-b border-white/[0.04]">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_1' | translate }}</span>
                <span class="text-gray-350">{{ 'COMPARISON.VAL_YES' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5 border-b border-white/[0.04]">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_2' | translate }}</span>
                <span class="text-gray-650">{{ 'COMPARISON.VAL_NO' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5 border-b border-white/[0.04]">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_3' | translate }}</span>
                <span class="text-gray-650">{{ 'COMPARISON.VAL_NO' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_4' | translate }}</span>
                <span class="text-gray-650">{{ 'COMPARISON.VAL_NO' | translate }}</span>
              </div>
            </div>
          </div>

          <!-- DistroKid -->
          <div class="bg-dark-300 border border-white/[0.04] rounded-2xl p-6" data-aos="fade-up" data-aos-delay="200">
            <div class="h-8 mb-4 flex items-center">
              <img src="other/Logo_of_DistroKid_(black).svg.png" alt="DistroKid" class="max-h-6 brightness-0 invert" />
            </div>
            <p class="text-xs text-gray-650 mb-5">Distribution</p>
            <div class="space-y-2.5 text-xs">
              <div class="flex justify-between items-center py-1.5 border-b border-white/[0.04]">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_1' | translate }}</span>
                <span class="text-gray-350">Upload</span>
              </div>
              <div class="flex justify-between items-center py-1.5 border-b border-white/[0.04]">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_2' | translate }}</span>
                <span class="text-gray-650">{{ 'COMPARISON.VAL_NO' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5 border-b border-white/[0.04]">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_3' | translate }}</span>
                <span class="text-gray-650">{{ 'COMPARISON.VAL_NO' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_4' | translate }}</span>
                <span class="text-gray-650">{{ 'COMPARISON.VAL_NO' | translate }}</span>
              </div>
            </div>
          </div>

          <!-- EVEN -->
          <div class="bg-dark-300 border border-white/[0.04] rounded-2xl p-6" data-aos="fade-up" data-aos-delay="300">
            <div class="h-8 mb-4 flex items-center">
              <img src="other/EVEN_Logo.jpg" alt="EVEN" class="max-h-6 rounded-sm mix-blend-screen opacity-90" />
            </div>
            <p class="text-xs text-gray-650 mb-5">Superfan drops</p>
            <div class="space-y-2.5 text-xs">
              <div class="flex justify-between items-center py-1.5 border-b border-white/[0.04]">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_1' | translate }}</span>
                <span class="text-gray-650">{{ 'COMPARISON.VAL_NO' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5 border-b border-white/[0.04]">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_2' | translate }}</span>
                <span class="text-gray-350">{{ 'COMPARISON.VAL_YES' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5 border-b border-white/[0.04]">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_3' | translate }}</span>
                <span class="text-gray-350">{{ 'COMPARISON.VAL_YES' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5">
                <span class="text-gray-450">{{ 'COMPARISON.ROW_4' | translate }}</span>
                <span class="text-gray-650">{{ 'COMPARISON.VAL_NO' | translate }}</span>
              </div>
            </div>
          </div>

          <!-- COLORFOL -->
          <div class="bg-dark-300 border border-primary/30 rounded-2xl p-6 relative" data-aos="fade-up" data-aos-delay="400">
            <div class="absolute -top-2.5 left-5 bg-primary text-white text-[10px] font-black px-2.5 py-0.5 rounded-full tracking-wide">COLORFOL</div>
            <div class="h-8 mb-4 flex items-center">
              <img src="logo.png" alt="COLORFOL" class="max-h-5" />
            </div>
            <p class="text-xs text-gray-350 mb-5">Direct-to-Fan + Distro</p>
            <div class="space-y-2.5 text-xs">
              <div class="flex justify-between items-center py-1.5 border-b border-primary/10">
                <span class="text-gray-350">{{ 'COMPARISON.ROW_1' | translate }}</span>
                <span class="text-white font-bold">{{ 'COMPARISON.VAL_YES' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5 border-b border-primary/10">
                <span class="text-gray-350">{{ 'COMPARISON.ROW_2' | translate }}</span>
                <span class="text-accent-green font-bold">{{ 'COMPARISON.VAL_YES' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5 border-b border-primary/10">
                <span class="text-gray-350">{{ 'COMPARISON.ROW_3' | translate }}</span>
                <span class="text-accent-green font-bold">{{ 'COMPARISON.VAL_YES' | translate }}</span>
              </div>
              <div class="flex justify-between items-center py-1.5">
                <span class="text-gray-350">{{ 'COMPARISON.ROW_4' | translate }}</span>
                <span class="text-primary font-black">{{ 'COMPARISON.VAL_NATIVE' | translate }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  `
})
export class ComparisonComponent {}
